angular.module('rjmNg.constants').constant 'clientEventTypes',
  Object.freeze
    FIRST_CONNECTION_ADDED: 1
    IMPLEMENTATION_FORMS_COMPLETED: 2
    FIRST_FIELDS_TRACKED: 3
    FIRST_CONNECTION_SAVED: 4
    FREE_TRIAL_MONTH_STARTED: 5
    FIRST_FILE_UPLOAD: 6
    FIRST_DATA_ADDED: 7
    FIRST_USERPUSH_TABLE_CREATED: 8
    FREE_TRIAL_WARNING_EMAIL_SENT: 9
    FREE_TRIAL_EXTENSION_EMAIL_SENT: 10
    FREE_TRIAL_OVER: 11
    FIRST_PAYMENT_EMAIL_SENT: 12
    FIRST_PAYMENT_PROCESSED: 13
    BILLING_ENTERPRISE_UPGRADE_SENT: 14
    BILLING_PRICING_UPGRADE_WARNING_SENT: 15
    BILLING_ENTERPRISE_UPGRADE_WARNING_SENT: 16
    PAYPAL_SUBMIT_BUTTON_CLICKED: 17
    NON_BRAINTREE_UPGRADE_SENT: 18
    NO_USER_COLUMN_WARNING_SENT: 19
    PARDOT_FIRST_PAYMENT_SYNCED: 20
    OVERDUE_BILLING_RAN: 21
    FREE_TRIAL_DEACTIVATION: 22
    IMPLEMENTATION_BILLING_SKIPPED: 23
    IMPLEMENTATION_BILLING_ENTERED: 24
    BILLING_SUBSCRIPTION_LAPSE_WARNING_SENT: 25
    GENERATED_FIRST_API_KEY: 26
    USER_CONTRACT_EMAIL_SENT: 27
